import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { type CSSProperties, type ReactNode } from 'react';

import s from '../EventWizardModal.module.scss';

export function SortableLocationRow({
  id,
  name,
  hint,
  index,
  onRemove,
}: {
  id: number;
  name: string;
  /** The quieter line under the name, as the suggestion showed it. */
  hint?: ReactNode;
  index: number;
  onRemove: () => void;
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });
  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : undefined,
    zIndex: isDragging ? 1 : undefined,
    cursor: isDragging ? 'grabbing' : 'grab',
  };
  return (
    <div ref={setNodeRef} style={style} className={s.locationRow} {...attributes} {...listeners}>
      <span className={s.locationIndex}>{index + 1}</span>
      <span className={s.locationPin}>📍</span>
      <span className={s.locationName}>
        {name}
        {hint && <span className={s.locationHint}>{hint}</span>}
      </span>
      <button
        type="button"
        className={s.removeBtn}
        onClick={onRemove}
        onPointerDown={(e) => e.stopPropagation()}
        aria-label={`Remove ${name}`}
      >
        ✕
      </button>
    </div>
  );
}
